export default "__VITE_ASSET__e5dlovmn__"